// routes
import { PATH_AUTH } from "../routes/paths";
// utils
import axios from "../utils/axios";
import localStorageAvailable from "../utils/localStorageAvailable";
import { updateSocketAccessToken } from "../utils/socket";
const backendUrl = process.env.REACT_APP_BACKEND_URL;
// ----------------------------------------------------------------------

function jwtDecode(token) {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split("")
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join("")
  );

  return JSON.parse(jsonPayload);
}

// ----------------------------------------------------------------------

export const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  }

  const decoded = jwtDecode(accessToken);

  const currentTime = Date.now() / 1000;

  return decoded.exp > currentTime;
};

// ----------------------------------------------------------------------

export const tokenExpired = (exp) => {
  // eslint-disable-next-line prefer-const
  let expiredTimer;

  const currentTime = Date.now();

  // Test token expires after 10s
  // const timeLeft = currentTime + 10000 - currentTime; // ~10s
  const timeLeft = exp * 1000 - currentTime;

  clearTimeout(expiredTimer);

  expiredTimer = setTimeout(async() => {
    alert("Token expired");
    const storageAvailable = localStorageAvailable();
    const refreshToken = storageAvailable? sessionStorage.getItem("refreshToken"): "";
    const accessToken = storageAvailable? sessionStorage.getItem("accessToken"): "";
    const response = await axios.post(`${backendUrl}/auth/token-expired`,{ accessToken, refreshToken } );
    
    sessionStorage.removeItem("accessToken");
    sessionStorage.removeItem("refreshToken");
    updateSocketAccessToken(null);
   
    window.location.href = PATH_AUTH.login;
  }, timeLeft);
};

// ----------------------------------------------------------------------

export const setSession = (accessToken) => {
  if (accessToken) {
    sessionStorage.setItem("accessToken", accessToken);

    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    updateSocketAccessToken(accessToken);

    // This function below will handle when token is expired
    const { exp, isImpersonating } = jwtDecode(accessToken); // ~3 days by minimals server
    if (!isImpersonating) tokenExpired(exp);
  } else {
    sessionStorage.removeItem("accessToken");

    sessionStorage.removeItem("shiftEndTime");
    sessionStorage.removeItem("shiftStartTime");
    delete axios.defaults.headers.common.Authorization;
    updateSocketAccessToken(null);
  }
};

// ----------------------------------------------------------------------

export const setRefresh = (refreshToken) => {
  if (refreshToken) {
    sessionStorage.setItem("refreshToken", refreshToken);
  } else {
    sessionStorage.removeItem("refreshToken");
  }
};

// ----------------------------------------------------------------------

// Owners see everything; the role may come as a plain string (V1) or a role document (V2).
export const isOwner = (user) => {
  const role = user?.role?.name || user?.roleId?.name || user?.role;
  return typeof role === "string" && role.toLowerCase() === "owner";
};
